var render = function render(){var _vm=this,_c=_vm._self._c;return _c('img',{style:({ transform: _vm.rotation }),attrs:{"src":require("@/assets/Triangle.svg")}})
}
var staticRenderFns = []

export { render, staticRenderFns }